export interface LayoutState {
    ttDev: boolean;
    scrolling: boolean;
    questionScrolling: number;
    mobileFoldersOpened: boolean;
}

export const initialState: LayoutState = {
    ttDev: false,
    scrolling: false,
    questionScrolling: null,
    mobileFoldersOpened: false,
};
